import { render, staticRenderFns } from "./AdminCaixasForm.vue?vue&type=template&id=225a44ca&scoped=true"
import script from "./AdminCaixasForm.vue?vue&type=script&lang=js"
export * from "./AdminCaixasForm.vue?vue&type=script&lang=js"
import style0 from "./AdminCaixasForm.vue?vue&type=style&index=0&id=225a44ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225a44ca",
  null
  
)

export default component.exports